/* b1b2-tea-boba page JS: buybox logic, gallery, timer. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- compare table column selector (mobile) ----------
       The cloned markup expects the vendor's nss-comparison-table element,
       which this theme does not ship. This block gives the dropdown the
       same behaviour: open the list, pick a column, show that column. */
    $$('nss-comparison-table').forEach(function (table) {
      var selector = $('.nss-comparison-table__column-selector', table);
      var openBtn = $('[nss-selected-column-btn]', table);
      var labelEl = $('[nss-selected-column]', table);
      if (!selector || !openBtn) return;
      openBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        selector.classList.toggle('nss-active');
      });
      $$('ul li button[nss-column-id]', selector).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var id = btn.getAttribute('nss-column-id');
          $$('ul li button[nss-column-id]', selector).forEach(function (b) {
            b.classList.toggle('nss-active', b === btn);
          });
          $$('.nss-comparison-table__column[nss-column-id]', table).forEach(function (col) {
            var colId = col.getAttribute('nss-column-id');
            if (colId) col.classList.toggle('nss-active', colId === id);
          });
          if (labelEl) labelEl.textContent = btn.textContent.trim();
          selector.classList.remove('nss-active');
        });
      });
      document.addEventListener('click', function () {
        selector.classList.remove('nss-active');
      });
    });

    var summary = $('#sb-b1b2-summary');
    if (!summary) return;

    /* ---------- nutrition label popup ----------
       Ported from pdp-v3-main. Delegated clicks; the modal moves to the
       body so no transformed ancestor can capture its fixed position. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-b1b2-nutrition-open]')) {
        var m = document.querySelector('[data-b1b2-nutrition-modal]');
        if (m) { document.body.appendChild(m); m.removeAttribute('hidden'); }
        return;
      }
      if (t.closest('[data-b1b2-nutrition-close]')) {
        var mc = document.querySelector('[data-b1b2-nutrition-modal]');
        if (mc) mc.setAttribute('hidden', '');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var m = document.querySelector('[data-b1b2-nutrition-modal]');
        if (m) m.setAttribute('hidden', '');
      }
    });

    /* ---------- rating row scrolls to the reviews section ---------- */
    var rating = $('.sb-b1b2-title-rating');
    if (rating) rating.addEventListener('click', function () {
      var target = document.querySelector('.shopify-section[id*="b1b2_reviews"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* ---------- gallery thumbs ---------- */
    var mainImg = $('[data-b1b2-main-img]');
    $$('.sb-b1b2-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.sb-b1b2-thumb').forEach(function (x) { x.classList.remove('nss-active'); });
        t.classList.add('nss-active');
        var img = t.querySelector('img');
        if (mainImg && img) mainImg.src = img.getAttribute('data-full') || img.src;
      });
    });

    /* Thumbnail arrows, same behaviour as pdp-v4-main. */
    $$('[data-b1b2-thumb-arrow]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var strip = arrow.closest('.sb-b1b2-thumbs-row').querySelector('.sb-b1b2-thumbs');
        if (!strip) return;
        var dir = arrow.getAttribute('data-b1b2-thumb-arrow') === 'next' ? 1 : -1;
        strip.scrollBy({ left: dir * 180, behavior: 'smooth' });
      });
    });

    /* ---------- countdown timer (rolling 5h window) ---------- */
    var end = Date.now() + 5 * 3600 * 1000;
    if ($('[data-t-h]')) setInterval(function () {
      var left = Math.max(0, end - Date.now()) / 1000;
      var h = String(Math.floor(left / 3600)).padStart(2, '0');
      var m = String(Math.floor(left / 60) % 60).padStart(2, '0');
      var sec = String(Math.floor(left) % 60).padStart(2, '0');
      $$('[data-t-h]').forEach(function (e) { e.textContent = h; });
      $$('[data-t-m]').forEach(function (e) { e.textContent = m; });
      $$('[data-t-s]').forEach(function (e) { e.textContent = sec; });
    }, 1000);

    /* ---------- state ---------- */
    var state = { qty: 2, mode: 'sub' };

    var cfg = {
      subPlanId: summary.getAttribute('data-sub-plan-id'),
      pearlsVariant: summary.getAttribute('data-pearls-variant'),
      strawVariant: summary.getAttribute('data-straw-variant'),
      subCodes: { 1: summary.getAttribute('data-sub-code-1'), 2: summary.getAttribute('data-sub-code-2') },
      otpCodes: { 1: summary.getAttribute('data-otp-code-1'), 2: summary.getAttribute('data-otp-code-2') },
      giftCode: summary.getAttribute('data-gift-code')
    };

    /* ---------- flavour picker ----------
       One picker for the whole buybox. The JS moves it into the selected
       purchase card and shows one row per bag. Same pattern as
       snippets/sb-bogo-block.liquid. */
    var flavorsEl = $('[data-b1b2-flavors]');
    var flavorRows = $$('[data-b1b2-flavor-row]');
    function updateFlavors(card) {
      if (!flavorsEl || !card) return;
      var slot = card.querySelector('[data-b1b2-flavor-slot]');
      if (slot && flavorsEl.parentNode !== slot) slot.appendChild(flavorsEl);
      flavorRows.forEach(function (row, i) {
        row.style.display = i < state.qty ? '' : 'none';
      });
    }

    /* ---------- purchase mode and size ----------
       There is one card for each mode. Each card holds its own size toggle.
       Both toggles always show the same size, so the size stays the same when
       the shopper changes the mode. */
    var modeCards = $$('[data-b1b2-mode-card]');
    var sizeButtons = $$('[data-b1b2-size]');
    function cardForMode(mode) {
      for (var i = 0; i < modeCards.length; i++) {
        if (modeCards[i].getAttribute('data-b1b2-mode-card') === mode) return modeCards[i];
      }
      return null;
    }
    /* Writes the card header prices, the toggle state, and the bundle tag. */
    function syncSize() {
      var data = window.SB_B1B2_PRICES || {};
      $$('[data-b1b2-price]').forEach(function (el) {
        var set = data[el.getAttribute('data-b1b2-price')];
        var row = set && set[state.qty];
        if (row) el.textContent = row[el.getAttribute('data-b1b2-field')] || '';
      });
      sizeButtons.forEach(function (btn) {
        var on = parseInt(btn.getAttribute('data-b1b2-size'), 10) === state.qty;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function setSize(n) {
      state.qty = n;
      syncSize();
      updateFlavors(cardForMode(state.mode));
    }
    /* Selecting one-time collapses the card above it, so the one-time card
       jumps up the screen by the height the subscription card just lost. The
       subscription card never jumps, because nothing sits above it. Measure
       the clicked card before and after, then scroll by the difference, so
       the card the shopper clicked stays where they are looking. */
    function setMode(mode, keepInPlace) {
      var card = cardForMode(mode);
      var before = keepInPlace && card ? card.getBoundingClientRect().top : 0;
      state.mode = mode;
      modeCards.forEach(function (c) {
        var on = c.getAttribute('data-b1b2-mode-card') === mode;
        c.classList.toggle('nss-active', on);
        var input = c.querySelector('input[type=radio]');
        if (input) input.checked = on;
      });
      summary.classList.toggle('sb-b1b2-otp-on', mode === 'once');
      updateFlavors(card);
      syncSize();
      if (keepInPlace && card) {
        var delta = card.getBoundingClientRect().top - before;
        if (delta) {
          /* The theme sets scroll-behavior: smooth on <html>, which would
             animate this correction and show the jump it is meant to hide.
             Turn it off for the one scroll, then put it back. */
          var root = document.documentElement;
          var prev = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          window.scrollBy(0, delta);
          root.style.scrollBehavior = prev;
        }
      }
    }
    modeCards.forEach(function (card) {
      var label = card.querySelector('label');
      if (!label) return;
      label.addEventListener('click', function () {
        setMode(card.getAttribute('data-b1b2-mode-card'), true);
      });
    });
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSize(parseInt(btn.getAttribute('data-b1b2-size'), 10));
      });
    });

    /* flavour variant ids for the visible rows only */
    function selectedFlavorVariants() {
      return flavorRows.slice(0, state.qty).map(function (row) {
        var t = row.querySelector('[data-b1b2-cs-trigger]');
        return t ? t.getAttribute('data-variant-id') : '';
      }).filter(Boolean);
    }

    /* ---------- flavor drawer ----------
       One drawer serves every bag row. A row click opens it, a card click
       writes the pick back into the row trigger. The trigger keeps the
       data-variant-id contract selectedFlavorVariants() reads. The drawer
       moves onto the body on first open, the same way the nutrition modal
       does, so no transformed ancestor can capture its fixed position. */
    var fd = $('[data-b1b2-fd]');
    var fdTitle = fd ? $('[data-b1b2-fd-title]', fd) : null;
    var fdTabs = fd ? $$('[data-b1b2-fd-tab]', fd) : [];
    var fdActiveBag = 0;
    function fdTriggerForBag(i) {
      var row = flavorRows[i];
      return row ? row.querySelector('[data-b1b2-cs-trigger]') : null;
    }
    /* Tabs mirror the bag rows: one tab per visible bag, the active tab is
       the bag being chosen, and each tab shows its current pick. */
    function fdSyncTabs() {
      fdTabs.forEach(function (tab, i) {
        if (i >= state.qty) { tab.hidden = true; return; }
        tab.hidden = false;
        tab.classList.toggle('is-active', i === fdActiveBag);
        var trigger = fdTriggerForBag(i);
        var pickEl = tab.querySelector('[data-b1b2-fd-tab-pick]');
        var labelEl = trigger ? trigger.querySelector('.sb-b1b2-cs-label') : null;
        if (pickEl) pickEl.textContent = labelEl ? labelEl.textContent : '';
      });
      if (fdTitle) {
        fdTitle.textContent = state.qty > 1
          ? 'Step ' + (fdActiveBag + 1) + ' of ' + state.qty + ' · Choose the tea for Bag ' + (fdActiveBag + 1)
          : 'Choose your tea';
      }
      var trigger = fdTriggerForBag(fdActiveBag);
      var current = trigger ? trigger.getAttribute('data-variant-id') : '';
      $$('[data-b1b2-fd-option]', fd).forEach(function (o) {
        o.classList.toggle('is-selected', o.getAttribute('data-variant-id') === current);
      });
    }
    function openFlavorDrawer(bagIndex) {
      if (!fd) return;
      if (fd.parentNode !== document.body) document.body.appendChild(fd);
      fdActiveBag = Math.min(bagIndex, state.qty - 1);
      fdSyncTabs();
      fd.removeAttribute('hidden');
      document.body.classList.add('sb-b1b2-fd-open');
      var selected = fd.querySelector('[data-b1b2-fd-option].is-selected') || fd.querySelector('[data-b1b2-fd-option]');
      if (selected) selected.focus();
    }
    function closeFlavorDrawer() {
      if (!fd || fd.hasAttribute('hidden')) return;
      fd.setAttribute('hidden', '');
      document.body.classList.remove('sb-b1b2-fd-open');
      var trigger = fdTriggerForBag(fdActiveBag);
      if (trigger) trigger.focus();
    }
    $$('[data-b1b2-cs-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var row = trigger.closest('[data-b1b2-flavor-row]');
        openFlavorDrawer(row ? flavorRows.indexOf(row) : 0);
      });
    });
    if (fd) {
      fdTabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          fdActiveBag = i;
          fdSyncTabs();
        });
      });
      $$('[data-b1b2-fd-option]', fd).forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.disabled || opt.classList.contains('is-sold-out')) return;
          var trigger = fdTriggerForBag(fdActiveBag);
          if (trigger) {
            trigger.setAttribute('data-variant-id', opt.getAttribute('data-variant-id'));
            var labelEl = trigger.querySelector('.sb-b1b2-cs-label');
            if (labelEl) labelEl.textContent = opt.getAttribute('data-title');
            var imgEl = trigger.querySelector('.sb-b1b2-cs-img');
            var img = opt.getAttribute('data-img');
            if (imgEl && img) imgEl.src = img;
          }
          /* The pick completes this bag. Move to the next bag, or close
             after the last one, so the overlay reads as steps. */
          if (fdActiveBag < state.qty - 1) {
            fdActiveBag += 1;
            fdSyncTabs();
          } else {
            closeFlavorDrawer();
          }
        });
      });
      $$('[data-b1b2-fd-close]', fd).forEach(function (el) {
        el.addEventListener('click', closeFlavorDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeFlavorDrawer();
      });
    }

    /* ---------- cart ---------- */
    /* Re-render the drawer from the section, then slide it open. The section
       id is 'sb-cart-drawer' because layout/theme.lp.liquid renders it.
       Falls back to /cart if the drawer is not on the page. */
    function openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) { window.location.href = '/cart'; return Promise.resolve(); }
      return fetch(window.location.pathname + '?sections=sb-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['sb-cart-drawer'];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('#CartDrawer');
            var target = document.getElementById('CartDrawer');
            if (fresh && target) target.innerHTML = fresh.innerHTML;
            var freshRoot = doc.querySelector('cart-drawer');
            if (freshRoot) drawer.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
          }
          if (typeof drawer._syncCartState === 'function') drawer._syncCartState();
          if (typeof drawer._rebindAll === 'function') drawer._rebindAll();
          drawer.open();
        })
        .catch(function () { window.location.href = '/cart'; });
    }

    function goCheckout(mode) {
      var items = selectedFlavorVariants().map(function (id) {
        var line = { id: parseInt(id, 10), quantity: 1 };
        if (mode === 'sub' && cfg.subPlanId) line.selling_plan = parseInt(cfg.subPlanId, 10);
        return line;
      });
      if (!items.length) { alert('Please pick your flavor first.'); return; }
      if (cfg.pearlsVariant) items.push({ id: parseInt(cfg.pearlsVariant, 10), quantity: 1 });
      if (mode === 'sub' && cfg.strawVariant) items.push({ id: parseInt(cfg.strawVariant, 10), quantity: 1 });

      var codes = [];
      var tierCode = (mode === 'sub' ? cfg.subCodes : cfg.otpCodes)[state.qty];
      if (tierCode) codes.push(tierCode);
      if (mode === 'sub' && cfg.giftCode) codes.push(cfg.giftCode);

      var btn = mode === 'sub' ? $('[data-b1b2-atc-sub]') : $('[data-b1b2-atc-otp]');
      if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'ADDING...'; }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add to cart failed'); });
          return r.json();
        })
        .then(function () {
          /* register each discount code, then go to checkout with codes in the URL too */
          var chain = Promise.resolve();
          codes.forEach(function (c) {
            chain = chain.then(function () { return fetch('/discount/' + encodeURIComponent(c)); });
          });
          return chain;
        })
        .then(function () {
          /* Open the slide-out cart. Leon: adding must not jump to checkout.
             The discount codes are already registered on the cart above, so
             the drawer's own checkout button carries them. */
          return openDrawer();
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.querySelector('span').textContent = mode === 'sub' ? 'START MY RITUAL' : 'TRY ONCE'; }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.querySelector('span').textContent = mode === 'sub' ? 'START MY RITUAL' : 'TRY ONCE'; }
          alert('Sorry, something went wrong: ' + err.message);
        });
    }

    var subBtn = $('[data-b1b2-atc-sub]');
    if (subBtn) subBtn.addEventListener('click', function () { goCheckout('sub'); });
    var otpBtn = $('[data-b1b2-atc-otp]');
    if (otpBtn) otpBtn.addEventListener('click', function () { goCheckout('once'); });

    setMode(state.mode);
  });
})();
